import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Contact } from 'common/store/genesys-cloud/external-contacts/models/contact.model';

@Component({
  selector: 'app-genesys-contact-display-name',
  templateUrl: './genesys-contact-display-name.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysContactDisplayNameComponent {
  @Input()
  contact: Contact;
}
